import React, { useState,useEffect,useRef,useContext,useMemo,useCallback   } from "react";
import '../../components_css/chat_content.css'
import '../../components_css/chat_menu.css'

import { Link,useParams,useNavigate  } from "react-router-dom";
import ReactGA from 'react-ga4';


import helpers from "../_helpers/helpersFunction";

import Lang from '../lang/translations';
import Context from '../context/context';
import helpersFunction from "../_helpers/helpersFunction";

import Testing_dumgum from "./testing_dumgum";
import { servizi } from '../_helpers/configServizi';



const MessageBubble = ({ isRight, day, time, children }) => {
    const alignmentClass = isRight ? "right" : "left";
    const bgClass = !isRight ? "angleMsg" : "";
    return (
        <li className={`${alignmentClass} clearfix`}>
            <div
				className={`chat-body clearfix ${bgClass}`}
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: isRight ? "flex-end" : "flex-start",
					maxWidth: "60%",
				}}
			>
                {children}
                <div className="footer_msg d-flex justify-content-between pt-1">
                    <span />
                    <span className="messaggioOra">
                        {day && `${day}-`}
                        {isRight ? <strong>{time}</strong> : time}
                        {isRight && (
                            <span className="delivery-status sent-now">
                                <i className="ml-1 fa fa-check-double send"></i>
                            </span>
                        )}
                    </span>
                </div>
            </div>
        </li>
    );
};

const PersonalContent = ({ msg, displayDisclaimer, context, navigate, profiloAttuale }) => (
    <>
        {displayDisclaimer === "displayDisclamer" && (
            <p className={displayDisclaimer}>
                <i className="fas fa-exclamation-triangle" /> 
                <Link to="/purchase" onClick={() => {
                    context.setPaymentPageText({...context.paymentPageText, text1: "non_paghi_nulla", header1: "verifica_profilo"});
                    context.setRateplanScelto(context.flusso.rateplan.sub[0]);
                    navigate('/purchase');
                }}>
                    <Lang w={"inserire_numero"} page={"chat_content"} placeholders={{angel: profiloAttuale.attuale.screenName}}/>
                </Link>
            </p>
        )}
        <p>{msg}</p>
    </>
);

const PhotoContent = ({ imageUrl, text, isRight }) => {
    const [loaded, setLoaded] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [size, setSize] = useState({ w: 300, h: 200 });
	const [naturalSize, setNaturalSize] = useState({ w: 0, h: 0 });
	const toggleFullScreen = () => setIsFullScreen(!isFullScreen);

    return (
        <>
            {/* MESSAGE IMAGE */}
            <div
				className="mb-2"
				style={{
					display: "flex",
					justifyContent: 'auto',
					width: '100%',
					contentVisibility: 'auto',
					containIntrinsicSize: 'auto 250px'  // Riserva lo spazio per le immagini quando sono fuori viewport
					}}
			>
				<div className="photoMsgWrapper" onClick={toggleFullScreen}>
					<img 
						className="photoMsgImage"
						src={imageUrl}
						loading="lazy"
						alt="Foto inviata"
					/>
					{text && (
						<div className="photoMsgText" >
							{text}
						</div>
					)}
				</div>
			</div>

            {/* FULLSCREEN */}
            {isFullScreen && (
				<div className="photoFullscreen" onClick={toggleFullScreen} >
					<img
						src={imageUrl}
						alt="Full Screen"
						className="photoFullscreenImg"
					/>
					<div className="photoFullscreenClose">
						<i className="fas fa-times"></i>
					</div>
				</div>
			)}
        </>
    );
};

const AngelContent = ({ messaggio, context, helpers, navigate, profiloAttuale, params }) => {
    const isPremium = context.premiumLevel > 0;
    const messaggioDaVisualizzare = (!isPremium && messaggio.blurredMessage) ? messaggio.blurredMessage : messaggio.msg;
    return (
        <>
            {messaggio.idNotifica === "benvenuto" ? (
                <p dangerouslySetInnerHTML={{ __html: messaggioDaVisualizzare }}></p>
            ) : (
                <p>{messaggioDaVisualizzare}</p>
            )}
            {messaggio.blurredMessage && !isPremium && (
                <Link className="bottoneMessaggioHook" onClick={() => {
                    helpers.showHook("blurred", profiloAttuale.attuale, context, navigate);
                    helpers.eventPost(localStorage.getItem('trackerId'), params.u, "lettura_pressing");
                }}>
                    <Lang w={"hook_blurred"} page={"chat_content"}/>
                </Link>
            )}
        </>
    );
};

const ChatMessage = ({ messaggio, helpers, params, context, navigate, profiloAttuale }) => {
    if (!messaggio || new Date(messaggio.time) > new Date() || messaggio.angelId !== params.u || messaggio.type === "like") return null;
    const messageDate = new Date(messaggio.time);
    const day = !helpers.isToday(messageDate) ? messageDate.toLocaleDateString() : "";
    const time = `${messageDate.getHours()}:${String(messageDate.getMinutes()).padStart(2, '0')}`;
	const localTrackerId = localStorage.getItem('trackerId');
    const isPersonal =   messaggio.from === "user" || messaggio.trackerId === localTrackerId;


    let content;
    switch (messaggio.type) {
        case "personal":
            content = <PersonalContent msg={messaggio.msg} displayDisclaimer="dontDisplayDisclaimer" context={context} navigate={navigate} profiloAttuale={profiloAttuale} />;
            break;
        case "photo":
            content = (
				<PhotoContent 
					imageUrl={messaggio.img_url}
					text = {messaggio.msg}
					isRight={isPersonal}
				/>
				
			);
            break;
        default:
            content = <AngelContent messaggio={messaggio} context={context} helpers={helpers} navigate={navigate} profiloAttuale={profiloAttuale} params={params} />;
            break;
    }
    return <MessageBubble isRight={isPersonal} day={day} time={time}>{content}</MessageBubble>;
};

const MessageList = React.memo(({ messaggiPrecedenti, profiloAttuale, invito_non_risposto, helpers, params, context, navigate }) => {
    if (!messaggiPrecedenti || messaggiPrecedenti.length === 0) {
        return (
            <div className="chat messageArea" id="chatHeight">
                <div className="text-center absolute_icebreaker">
                    <p><Lang w={"non_essere_timido"} page={"chat_content"} placeholders={{angel:profiloAttuale.attuale.screenName}}/></p>
                </div>
                <div id="bottom-chat-marker" style={{ height: '1px', width: '100%' }}></div>
            </div>
        );
    }
    if (messaggiPrecedenti.every(m => m.type === "like")) {
        return (
            <div className="chat messageArea" id="chatHeight">
                <div className="text-center absolute_icebreaker">
                    <p><Lang w={"ha_visitato"} page={"chat_content"}/></p>
                </div>
                <div id="bottom-chat-marker" style={{ height: '1px', width: '100%' }}></div>
            </div>
        );
    }

	
    return (
		
        <>
            <ul className="chat messageArea" id="chatHeight">
                {messaggiPrecedenti.map((msg, i) => (
                    <ChatMessage key={i} messaggio={msg} helpers={helpers} params={params} context={context} navigate={navigate} profiloAttuale={profiloAttuale} />
                ))}
            </ul>
            <div id="bottom-chat-marker" style={{ height: '1px', width: '100%' }}></div>
            <div className="spacerMsg"></div>
            {invito_non_risposto && (
                <div className="text-center chat_inibita">
                    <span className="colored">{profiloAttuale.attuale.screenName}</span><br />
                    Non ha ancora accettato il tuo invito
                </div>
            )}
        </>
    );
});

export default function Chat_content(props) {

	useEffect(() => {
        const handleOverflow = () => {
            if (window.innerWidth >= 1000) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }
        };

        handleOverflow();
        window.addEventListener('resize', handleOverflow);

		return () => {
			document.body.style.overflow = 'auto';
            window.removeEventListener('resize', handleOverflow);
		};
	}, []);
	
	const [country, SetCountry] = useState(helpers.getCountry());
	const {collection_folder, default_folder} = helpers.getCDNfolder()
	var trackerId = localStorage.getItem('trackerId');
	
	let params = useParams();
	let navigate = useNavigate();

	const [profiloAttuale, setProfiloAttuale] =  useState({"attuale":{screenName:"",id:"",id:""}}); 
	const [messaggiPrecedenti, setMessaggiPrecedenti] = useState([]);
	const [msg, setMessaggio] = useState("");
	const [messaggioPrecompilato, setMessaggioPrecompilato] = useState(Boolean);
	const [avatar, setAvatar] = useState(localStorage.getItem('avatar') ? localStorage.getItem('avatar') : "/img/avatar.png");
	const [icebreaker, setIcebreaker] = useState();
	const [staScrivendo, setStascrivendo] = useState(false);
	const [waiter, setWaiter] = useState(true);
	const [invito_non_risposto, setinvito_non_risposto] = useState(null);
	const [menuChatAperto, setMenuChatAperto] = useState(false);
	const [confermaChatElimina, setConfermaChatElimina] = useState(false);

	useEffect(() => {
		if (!menuChatAperto) return;
		const chiudi = () => { setMenuChatAperto(false); setConfermaChatElimina(false); };
		document.addEventListener('click', chiudi);
		return () => document.removeEventListener('click', chiudi);
	}, [menuChatAperto]);

	const messaggioInput = useRef(null);
	const formMessaggio = useRef(null);
    const chatBoxRef = useRef(null);
	const isFirstNuovoMessaggio = useRef(true);
	const context = useContext(Context);

	// Stati locali per invio delle immagini con testo
	const [selectedImage, setSelectedImage] = useState(null);
	const [photoText, setPhotoText] = useState("");
	const [isPhotoPreviewOpen, setIsPhotoPreviewOpen] = useState(false);

	const fileInputRef = useRef(null);
	const abilitaFotoChat = servizi[window.location.hostname]?.abilita_foto_chat ?? true;

	var time = new Date();
	


	// Stato per finestra mobile o "larga" normale
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1000);
		};

		window.addEventListener("resize", handleResize);
		handleResize();

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const scrivi_un_messaggio = Lang( {"w": "scrivi_un_messaggio","page": "chat_content","var":true} );
	const fotoNonConformeTesto = Lang({ w: "foto_chat_non_conforme", page: "profilo" });

	const [fotoRifiutata, setFotoRifiutata] = useState(false);

	useEffect(() => {
		const handler = () => {
			setFotoRifiutata(true);
			setTimeout(() => setFotoRifiutata(false), 4000);
			setMessaggiPrecedenti(prev => {
				const lastPhotoIdx = [...prev].reverse().findIndex(m => m.type === "photo");
				if (lastPhotoIdx === -1) return prev;
				const actualIdx = prev.length - 1 - lastPhotoIdx;
				return prev.filter((_, i) => i !== actualIdx);
			});
		};
		context.Socket.on('foto_rifiutata', handler);
		return () => context.Socket.off('foto_rifiutata', handler);
	}, [context.Socket]);


    useEffect(() => {
        if (!chatBoxRef.current) return;

        const handleResize = () => {
            // Eseguiamo lo scroll piÃ¹ volte per coprire i tempi di ricalcolo del layout (es. scomparsa header)
            helpers.scrollToBottom();
            setTimeout(() => helpers.scrollToBottom(), 50);
            setTimeout(() => helpers.scrollToBottom(), 150);
            setTimeout(() => helpers.scrollToBottom(), 300);
            setTimeout(() => helpers.scrollToBottom(), 600);
        };

        const resizeObserver = new ResizeObserver(() => {
            handleResize();
        });

        resizeObserver.observe(chatBoxRef.current);
        window.addEventListener('resize', handleResize);

		
		


        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Effetto per scrollare quando finisce il caricamento
    useEffect(() => {
        if (!waiter) {
            setTimeout(() => helpers.scrollToBottom(), 100);
        }
    }, [waiter]);

	function CaricaMessaggiPrecedenti(messaggi){
		var msgs = []

		//prendo l'ultimo elemento dell'array
		var ultimoMessaggio = messaggi[messaggi.length - 1];
		if(ultimoMessaggio && ultimoMessaggio.letto == false){
			//calcolo il tempo trascorso in ms fra ora ed ultimoMessaggio.time
			var tempoTrascorso = new Date() - new Date(ultimoMessaggio.time);

			
		}

		for (let i = 0; i < messaggi.length; i++){
				
				if(new Date(messaggi[i].time) <= new Date()){
					msgs.push(messaggi[i]);
				}

				
		}
		return msgs || [];
	}

	async function controlloInvio(){
		const creditiMessaggi = parseInt(context.creditiMessaggi);
		const creditiIcebreaker = parseInt(context.creditiIcebreaker);
		const valoreMessaggio = context.premiumLevel == 0 ? 1 : context.valoreMessaggio;

		if(context.premiumLevel == 0){
			if(icebreaker){
				if(creditiIcebreaker > 0 || creditiMessaggi > 0){
					return true;
				} else {
					helpersFunction.eventPost(trackerId, params.u, "ko_icebreaker");
					return false;
				}
			} else {
				if(creditiMessaggi > 0){
					return true;
				} else {
					helpersFunction.eventPost(trackerId, params.u, "ko_msg");
					return false;
				}
			}
		} else {
			const saldo = creditiMessaggi - valoreMessaggio;
			if(creditiMessaggi > 0 && saldo >= 0){
				return true;
			} else {
				helpersFunction.eventPost(trackerId, params.u, "ko_msg");
				return false;
			}
		}
	}

	async function hookToChatSubmit(event) {
		if (event.preventDefault) event.preventDefault();
		let testoMessaggio = '';
		let precompilato = 0;

		if (event.target && event.target.elements && event.target.elements.message) {
			testoMessaggio = event.target.elements.message.value;
			precompilato = 0;
		} else if (event.testo){
			testoMessaggio = event.testo;
			precompilato = 1;
		}

		testoMessaggio = checkMessaggio(testoMessaggio) || testoMessaggio;

		if (!selectedImage && (!testoMessaggio || testoMessaggio.trim() == "")) return;

		if (selectedImage) {
			const messaggioFoto = creaNuovoMessaggioSocket({
				"type": "photo",
				"image": selectedImage,
				"msg": testoMessaggio
			});
			dispatchMessage(messaggioFoto);
			setSelectedImage(null);
			setIsPhotoPreviewOpen(false);
			setMessaggio("");
		} else {
			const messaggoTestuale = creaNuovoMessaggioSocket({
				"msg": testoMessaggio,
				"precompilato": precompilato,
				"type": 'personal'
			});
			dispatchMessage(messaggoTestuale);
			if (event.target && event.target.elements && event.target.elements.message) {
				event.target.elements.message.value = "";
			} else if (formMessaggio && formMessaggio.current) {
				formMessaggio.current.elements.message.value = "";
			}
		}
	}
	
	async function handlePhotoPreviewSend(event) {
		if (event.preventDefault) event.preventDefault();
		if (!selectedImage) return;

		const testoMessaggio = photoText || '';

		const messaggioFoto = creaNuovoMessaggioSocket({
			type: "photo",
			image: selectedImage,
			msg: testoMessaggio
		});

		dispatchMessage(messaggioFoto);

		setSelectedImage(null);
		setIsPhotoPreviewOpen(false);
		setPhotoText("");
	}

	async function dispatchMessage(messaggio) {
		var abilitato = await controlloInvio();

		if (abilitato) {
			if (props.verifiedUser) {
				context.Socket.emit('chat', messaggio);
				const tipologia_messaggio = icebreaker ? "icebreaker" : "no_icebreaker";

				if(tipologia_messaggio == "icebreaker"){
					helpers.kpiPanel(context, "send_icebreaker", null, null, null, { canon: "send_icebreaker", dedup: true })
					
				}else{
					//trovo in messaggiPrecedenti l'ultimo messaggio della angel cioè dove .type non è nè "like" nè "personal" 
					const ultimoMessaggio = messaggiPrecedenti.slice().reverse().find(m => m.type !== "like" && m.type !== "personal");
					
					//calcolo il tempo in ms trascorso fra ora ed ultimoMessaggio.time
					var tempoTrascorso = new Date() - new Date(ultimoMessaggio ? ultimoMessaggio.time : messaggio.time);
					helpers.kpiPanel(context, "ivio_msg_chat", tipologia_messaggio, null, null, { canon: "send_message", dedup: true, meta: { chat_id: profiloAttuale.attuale.id + "_" + trackerId, reply_latency_ms : tempoTrascorso } });	
				}
					

				if (helpers.isQualityMessage(messaggio.msg)) {
					helpers.kpiPanel(context, "send_quality_message", null, null, null, { canon: "send_quality_message", dedup: true, meta: { chat_id: profiloAttuale.attuale.id + "_" + trackerId } });
				}
			}

			var tempMsg = {
				"msg": messaggio.msg,
                "img_url": messaggio.img_url,
				"angelId":params.u,
				"time":time,
				"type":messaggio.type,
				"name":profiloAttuale.attuale.screenName,
				"image": messaggio.image,
				"trackerId" : localStorage.getItem("trackerId")
			};

			if(messaggiPrecedenti!=undefined){
				setMessaggiPrecedenti([...messaggiPrecedenti,tempMsg]);
			} else {
				setMessaggiPrecedenti([tempMsg]);
			}

			setMessaggio("")
			setMessaggioPrecompilato(false)
			setTimeout(() => {
				autoResizeTextarea();
			}, 0);
		} else {
			if(context.premiumLevel == 0) {
				context.setMessaggioPending(messaggio);
			}
			helpers.kpiPanel(context, "popup_hook", "fine_crediti", null, null, { canon: "view_paywall_credits", dedup: true, meta : { entrypoint : "chat_send"}})
			helpers.showHook("fine_crediti",profiloAttuale.attuale,context,navigate)
		}
	}

	async function getMeesagesAndProfile(angelID){
		setWaiter(true)
		const trackerId = localStorage.getItem('trackerId');
		const token = localStorage.getItem('token');
		
		if(params.u == context.nuovoMessaggio.angelId) context.nuovoMessaggio.letto = true;

		await fetch(process.env.REACT_APP_DISPENSER+"/"+params.u+"/"+country+"/"+context.user_info.cerco,{ 
			method: 'get', 
			headers: { 'Authorization': 'Bearer '+ token }
		})
		.then(response => response.json())
		.then(data => {
			if(data[0]) setProfiloAttuale({"attuale":data[0]});  
			else navigate('/');
		});
		
		if(angelID){
			fetch(process.env.REACT_APP_APIADDRESS+"/get/messages/"+trackerId+"/"+angelID,{ 
				method: 'get', 
				headers: { 'Authorization': 'Bearer '+ token }
			})
			.then(response => response.json())
			.then(data => {
				setWaiter(false)
				var messaggiPrec = CaricaMessaggiPrecedenti(data)
				setMessaggiPrecedenti(prev => {
					const ids = new Set(messaggiPrec.map(m => String(m._id)));
					const extra = prev.filter(m => !m._id || !ids.has(String(m._id)));
					return [...messaggiPrec, ...extra];
				});
				helpers.scrollToBottom();
			});
		}
	}

	useEffect(() => {
		if (!messaggiPrecedenti || messaggiPrecedenti.length === 0) {
			setIcebreaker(true);
			setinvito_non_risposto(false);
			return;
		}

		if (messaggiPrecedenti.every(m => m.type === "like")) setIcebreaker(true);
		else setIcebreaker(false);

		if (messaggiPrecedenti[0] && messaggiPrecedenti[0].type === "personal" && context.flusso.messaggi_inviti && messaggiPrecedenti.length === 1) {
			setinvito_non_risposto(true);
		} else {
			setinvito_non_risposto(false);
		}



		// Estrai l'angelId da qualsiasi messaggio della angel presente (escludendo like e personal)
		const messaggioAngel = messaggiPrecedenti.find(m =>
			m.type !== "like" &&
			m.type !== "personal" &&
			m.angelId
		);

		if (messaggioAngel && messaggioAngel.angelId) {
			const angelId = messaggioAngel.angelId;
			const meta = {
				chat_id: angelId + "_" + trackerId
			};

			// Popola read_latency_ms solo se il messaggio non è letto
			if (messaggioAngel.letto === false) {
				const messaggioTime = new Date(messaggioAngel.time);
				const tempoTrascorso = new Date() - messaggioTime;
				meta.read_latency_ms = tempoTrascorso;
			}

			helpers.kpiPanel(context, null, null, true, null, {
				canon: "read_reply",
				dedup: true,
				meta: meta
			});
		}
	}, [messaggiPrecedenti, context.flusso.messaggi_inviti]);

	useEffect(() => { helpers.scrollToBottom(); },[messaggiPrecedenti]);

	useEffect(() => { getMeesagesAndProfile(params.u); },[params.u]);
	
	useEffect(() => {
		if(isFirstNuovoMessaggio.current){ isFirstNuovoMessaggio.current = false; return; }
		if(context.nuovoMessaggio.msg != undefined){
			if(context.nuovoMessaggio.angelId == params.u){
				setStascrivendo(true)
				setTimeout(()=>{ 
					setMessaggiPrecedenti([...messaggiPrecedenti,context.nuovoMessaggio]);
					helpers.scrollToBottom()
					setStascrivendo(false)
				},5000)
			}else{
				setMessaggiPrecedenti([...messaggiPrecedenti,context.nuovoMessaggio]);
				helpers.scrollToBottom()
			}
		}
	},[context.nuovoMessaggio]);

	function handleGoBack () {
		navigate('/chats');
	};

	function disable_button(){
		if(params.u == "000000" || params.u == "111111" || params.u == "admin") return true;
		if(context.flusso.messaggi_inviti && invito_non_risposto) return true;
		return false;
	}

	function checkMessaggio(messaggio) {
		if (context.premiumLevel === 0) {
			if (messaggio != "") {
				const regex = /(\+?(?:(?:9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)|\((?:9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\))[0-9. -]{4,14})(?:\b|x\d+)/g;
				let m;
				var res = "";
				const is_present_number = regex.exec(messaggio);
				if (!is_present_number) {
					return messaggio;
				} else {
					while ((m = regex.exec(messaggio)) !== null) {
						if (m.index === regex.lastIndex) regex.lastIndex++;
						m.forEach((match) => { res = messaggio.replace(match, "XXXXXX"); });
					}
					return res;
				}
			}
		} else {
			return messaggio;
		}
	}

    function autoResizeTextarea() {
        const textarea = messaggioInput.current;
        if (textarea) {
            textarea.style.height = '43px';
            textarea.style.height = textarea.scrollHeight + 'px';
        }
    }

    function onChangeMessage(event) {
        setMessaggio(event.target.value);
        autoResizeTextarea();
    }

	function handleImageChange(event) {
		const file = event.target.files[0];
		if (!file) return;
		if(!file.type.startsWith('image/')) {
			alert('Per favore, seleziona un file immagine.');
			return;
		}
		// Per fare in modo cdi non perdere il messaggio se lo abbiamo scritto prima di aprire la selezione della foto
		// Salviamo subito il messaggio
		const testoAttuale = msg;

		setIcebreaker(true);

		processImage(file).then((base64) => {
			setSelectedImage(base64);
			// Ineriamo il testo prcedentemente scritto (non scritto -> si imposta vuoto)
			setPhotoText(testoAttuale);
			
			setIsPhotoPreviewOpen(true);
			event.target.value = null;
		}).catch((err) => {
			console.error('Errore processImage', err);
			alert('Errore durante il caricamento dell\'immagine. Riprova.');
		});
	}

	// Funzione per gestire il caricamento di una immagine prima di inviarla per aggiungere testo
	function handlePhotoSend(e) {
		e.preventDefault();

		const nuovoMessaggio = creaNuovoMessaggioSocket({
			type: "photo",
			image: selectedImage,
			msg: photoText
		});

		dispatchMessage(nuovoMessaggio);

		setSelectedImage(null);
		setPhotoText("");
		setIsPhotoPreviewOpen(false);
	}

	const processImage = (file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = (e) => {
				const img = new Image();
				img.onload = () => {
					const canvas = document.createElement('canvas');
					const MAX_WIDTH = 800;
					const MAX_HEIGHT = 600;
					let width = img.width;
					let height = img.height;
					if (width > height) {
						if(width > MAX_WIDTH) { height *= MAX_WIDTH / width; width = MAX_WIDTH; }
					} else {
						if (height > MAX_HEIGHT) { width *= MAX_HEIGHT / height; height = MAX_HEIGHT; }
					}
					canvas.width = width; canvas.height = height;
					const ctx = canvas.getContext('2d');
					ctx.drawImage(img, 0, 0, width, height );
					resolve(canvas.toDataURL('image/jpeg', 0.8));
				};
				img.src = e.target.result;
			};
			reader.readAsDataURL(file);
		});
	};

	function creaNuovoMessaggioSocket( customFields = {}) {
		const payload = {
			'trackerId': trackerId,
			'angelId': params.u,
			"screenName": profiloAttuale.attuale.screenName,
			"servizio": window.location.hostname,
			"country": country,
			"time": new Date().toISOString(),
			"blurredMessage": false,
			"precompilato": 0,
			"icebreaker": icebreaker,
			"provider": context.flusso.provider_animazione,
			...customFields
		};
		if (customFields.type === "photo") {
			payload.msg = customFields.msg;
            if(customFields.image) payload.img_url = customFields.image;
            payload.moderazione_foto = context.flusso?.moderazione_foto ?? null;
        }
		return payload;
	}

		function set_img_url(el) {
		console.log("Setto url immagine per ", el)
		if (el.gender === "male") {
			return "https://yp.cloudfileimages.com/uploads/photo/" + el.default_photo
		} else {
			return process.env.REACT_APP_CDN + "/" + default_folder + "/" + el.id + ".jpg"
		}
	}

	async function eseguiEliminaChat() {
		setMenuChatAperto(false);
		setConfermaChatElimina(false);
		const trackerId = localStorage.getItem('trackerId');
		const token = localStorage.getItem('token');
		try {
			await fetch(process.env.REACT_APP_APIADDRESS + '/chat/hide', {
				method: 'POST',
				headers: {
					'Authorization': 'Bearer ' + token,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ clickid: trackerId, angelId: params.u })
			});
		} catch (err) {
			console.log('Errore eseguiEliminaChat', err);
		}
		navigate('/chats');
	}


	function bloccaUtente(){
	
		const blocco = Lang( {"w": "utente_bloccato","page": "user"} );
		context.setTooltip({ visible: true, title: blocco,text:"",variant:"success",autoClose:true,tipo:"like"})

	}

    return (<div className="all-container bg-light page_chat">
		<div className="alert alert-primary alert-custom feedback_remove" role="alert" style={{ display: 'none' }} />
		<div className="filters-no-padding" role="main">
			<div className="main-chat row no-gutters">
			<div className="col-lg-12">
				<div className="connecting loader_chat invisible">
					<i className="fas fa-circle-notch fa-spin" />
				</div>
				<nav className="navbar_chat_mobile">
					<div className="navbar-collapse d-flex justify-content-between menumob">
						<div className="nameHeader">
							<a className="backChat" onClick={handleGoBack} >
								<i className="fa fa-chevron-left" aria-hidden="true"></i>
							</a>
							{profiloAttuale.attuale.id && (
								<Link to={"/user/" + profiloAttuale.attuale.id}>
									<img src={profiloAttuale.attuale.default_photo.startsWith("https://") ? profiloAttuale.attuale.default_photo : process.env.REACT_APP_CDN+"/"+default_folder+"/" + profiloAttuale.attuale.id + ".jpg"} alt="User Avatar" className="avatar_chat_mobile" />
								</Link>
							)}
							<div className="headerTextContainer">
								<div className="max-width-title text-nowrap title_page_box" style={{cursor: 'pointer'}}>
									<Link to={"/user/" + profiloAttuale.attuale.id}>{profiloAttuale.attuale.screenName}</Link>
								</div>
								<span className="status_navbar_mobile">
									{!staScrivendo ? (<Lang w={"disponibile"} page={"chat_content"}/>):(<Lang w={"sta_scrivendo"} page={"chat_content"}/>)}
								</span>
							</div>
						<div className="chat-menu-wrapper">
							<button className="chat-menu-btn" onClick={(e) => { e.stopPropagation(); setMenuChatAperto(!menuChatAperto); setConfermaChatElimina(false); }}>⋮</button>
							{menuChatAperto && (
								<>
									<div className="chat-dropdown" onClick={(e) => e.stopPropagation()}>
										{confermaChatElimina ? (
											<div className="chat-dropdown-confirm">
												<span><Lang w={"sei_sicuro"} page={"chat_content"}/></span>
												<button onClick={eseguiEliminaChat}><Lang w={"si"} page={"chat_content"}/></button>
												<button onClick={() => { setMenuChatAperto(false); setConfermaChatElimina(false); }}><Lang w={"no"} page={"chat_content"}/></button>
											</div>
										) : (
											<>
											<button onClick={() => setConfermaChatElimina(true)}><Lang w={"elimina_chat"} page={"chat_content"}/></button>
											{window.location.hostname === "jammydate.com" && (
												<button onClick={() => bloccaUtente()}><Lang w={"segnala_blocca"} page={"user"} /></button>
											)}
											
											</>
										)}
									</div>
								</>
							)}
						</div>
						</div>
					</div>
					</nav>

				<div className={waiter ? "chat-message waiter" : "chat-message" } id="chatArea">
					<MessageList 
						messaggiPrecedenti={messaggiPrecedenti} 
						profiloAttuale={profiloAttuale}
						invito_non_risposto={invito_non_risposto}
						helpers={helpers}
						params={params}
						context={context}
						navigate={navigate}
					/>
				</div>
				
				<div className="chat-box bg-gray" ref={chatBoxRef} >
					<input type="file" accept="image/*" style={{ display: 'none' }} ref={fileInputRef} onChange={handleImageChange} />

					{/* Overlay per foto preview */}
					{isPhotoPreviewOpen && selectedImage && (
						<div className="photoOverlay" >
							{/* CHIUDI (X) */}
							<button className="photoOverlayClose"
								type="button"
								onClick={() => {
									setSelectedImage(null);
									setIsPhotoPreviewOpen(false);
									setPhotoText("");
								}}
								
							>
								<i className="fas fa-times"></i>
							</button>

							{/* IMMAGINE */}
							<img
								className="photoOverlayImage"
								src={selectedImage}
								alt="preview"
							/>

							{/* MOBILE VS DESKTOP UI */}

							{isMobile ? (
								<form
									onSubmit={handlePhotoPreviewSend}
									className="photoOverlayFormMobile"
								>
									<textarea className="photoOverlayTextareaMobile"
										placeholder="Scrivi un messaggio"
										value={photoText}
										onChange={(e) => setPhotoText(e.target.value)}
									/>

									{/* FRECCIA INVIO */}
									<button
										className="photoOverlaySendButton"
										type="submit"
									>
										<i className="fas fa-arrow-right"></i>
									</button>
								</form>
							) : (
								<form
									onSubmit={handlePhotoPreviewSend}
									className="photoPreviewForm"
								>
									<textarea
										placeholder="Scrivi un messaggio (opzionale)"
										value={photoText}
										onChange={(e) => setPhotoText(e.target.value)}
										className="photoPreviewTextarea"
									/>

									{/* INVIA */}
									<button
										type="submit"
										className="btn btn-primary photoPreviewSend"
									>
										Invia
									</button>

									{/* ANNULLA */}
									<button
										type="button"
										className="btn btn-secondary photoPreviewCancel"
										onClick={() => {
											setSelectedImage(null);
											setIsPhotoPreviewOpen(false);
											setPhotoText("");
										}}
									>
										Annulla
									</button>
								</form>
							)}

						</div>
					)}
					{selectedImage && !isPhotoPreviewOpen && (
						<div className="selected-photo-preview" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: '8px' }}>
							<button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setSelectedImage(null)} style={{ marginRight: '8px' }}>Rimuovi foto</button>
							<img src={selectedImage} alt="Foto selezionata" style={{ maxHeight: '180px', maxWidth: '200px', width:'auto', borderRadius: '8px', objectFit: 'cover', boxShadow: '0 0 8px rgba(0,0,0,0.15)' }} />
						</div>
					)}
					{fotoRifiutata && (
					<div className="alert alert-danger" role="alert" style={{ margin: '0 0 8px 0', padding: '8px 12px', fontSize: '0.9em' }}>
						{fotoNonConformeTesto}
					</div>
				)}
				<form id="messageForm" ref={formMessaggio} onSubmit={hookToChatSubmit}>
						<div className="form-group">
							<div className="input-group clearfix">
								{abilitaFotoChat && (
									<button type="button" className="attach-button" onClick={() => fileInputRef.current?.click()} disabled={disable_button()}>
										<i className="far fa-image"></i>
									</button>
								)}
								<textarea id="message" name="message" placeholder={scrivi_un_messaggio} autoComplete="off" className="rounded form-control" value={msg} onChange={onChangeMessage} ref={messaggioInput} disabled={disable_button()} />
								<div className="input-group-append">
									<button type="submit" className={`chat_send_button ${msg != "" ? 'on' : ''} `} disabled={disable_button() || !msg || msg.trim() === ""} >
										Invia
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>);
}




